import { render, staticRenderFns } from "./project_formsub.vue?vue&type=template&id=36aaba3d&scoped=true"
import script from "./project_formsub.vue?vue&type=script&lang=js"
export * from "./project_formsub.vue?vue&type=script&lang=js"
import style0 from "./project_formsub.vue?vue&type=style&index=0&id=36aaba3d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aaba3d",
  null
  
)

export default component.exports